// web/src/screens/admin/popup_stack.ts
//
// A stack of "close" handles for the admin <dialog>-based modals (modal.ts).
// showModal() stacks dialogs in the top layer — the TextSet editor popup can
// have a "pick a Text" popup open on top of it — so a screen tearing down
// (via a widget's unmount()) must close ALL of them, not just the last-opened
// one, or an orphaned <dialog> lingers over the next screen.
//
// Each popup, on open, calls pushPopupClose(close) and keeps the returned
// "pop" fn; on its own close it calls pop() to unregister. closeOpenTextPopup()
// drains the stack (closing each, which triggers their own close listeners).

const closes: (() => void)[] = [];

/** Register a popup's close handle. Returns a fn that unregisters it. */
export function pushPopupClose(close: () => void): () => void {
  closes.push(close);
  return () => {
    const i = closes.indexOf(close);
    if (i >= 0) closes.splice(i, 1);
  };
}

/** Force-close every open admin popup (no-op if none). */
export function closeOpenTextPopup(): void {
  while (closes.length) closes.pop()!();
}
